import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Row
} from 'reactstrap';
import DetailRow from '../../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import ButtonIcon from '../../../components/common/ButtonIcon';
import FalconCardHeader from '../../../components/common/FalconCardHeader';
import RequiredMarked from '../../../components/common/RequiredMarked';
import { SolicitudContext } from '../SolicitudContext';
import ClientFormModal from '../ClientFormModal';
import { personsServices } from '../../../services';

const GeneralDataClient = () => {
  const context = useContext(SolicitudContext);
  const { client, adviser, onOpenModal, onSelectPagaduria, onSelectClient } = context;
  const [editingClient, setEditingClient] = useState(false);
  const [editable, setEditable] = useState(false);

  // el botón solo aparece si el backend permite corregir este cliente al usuario actual
  useEffect(() => {
    setEditable(false);
    if (!client || !client.id) return;
    personsServices.getEditable(client.id).then(r => setEditable(!!(r && r.editable)));
  }, [client && client.id]);

  return (
    <Card className={`my-3`} >
      <ClientFormModal
        open={editingClient}
        mode="editar"
        clientId={client && client.id}
        toggle={() => setEditingClient(false)}
        onSaved={onSelectClient}
      />
      <FalconCardHeader title="Datos Generales del Cliente">
        <div className="d-flex">
          {client && editable && (
            <ButtonIcon onClick={() => setEditingClient(true)} icon="edit" transform="shrink-3 down-2" color="falcon-default" size="sm" className="mr-2">
              Corregir datos
            </ButtonIcon>
          )}
          <ButtonIcon onClick={onOpenModal} icon="user" transform="shrink-3 down-2" color="falcon-default" size="sm">
            Buscar
          </ButtonIcon>
        </div>
      </FalconCardHeader>
      <CardBody className="bg-light border-top px-4">
        <>
          {adviser && (
            <Row>
              <Col lg={12} className="p-0" >
                <FormGroup>
                  <Label for="pagaduria">
                    <RequiredMarked />
                    Pagaduria
                  </Label>
                  <Select
                    placeholder="Seleccionar"
                    style="fullWidth-select"
                    name="Pagaduria"
                    onChange={(item) => onSelectPagaduria(item.value)}
                    options={adviser.asesorPagaduria.map(pag => ({ label: pag.infoPagaduria, value: pag.idPagaduria }))}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
          {client ? (
            <Row>
              <Col lg className="col-xxl-5">
                <DetailRow title="Identificación">{client.terceroInformacion.identificacion || <span className='p-2'></span>}</DetailRow>
                <DetailRow childrenClasses="text-uppercase" title="Telefono">{client.terceroUbicacion.telefono1 || <span className='p-2'></span>}</DetailRow>
              </Col>
              <Col lg className="col-xxl-5 mt-4 mt-lg-0 offset-xxl-1">
                <DetailRow childrenClasses="text-uppercase" title="Razon Social o Nombre del Cliente">{
                  `${client.terceroInformacion.nombre1} ${client.terceroInformacion.nombre2}
              ${client.terceroInformacion.apellido1} ${client.terceroInformacion.apellido2}` ||
                  <span className='p-2'></span>
                }</DetailRow>
                <DetailRow childrenClasses="text-uppercase" title="Correo">{client.terceroUbicacion.correo || <span className='p-2'></span>}</DetailRow>
              </Col>
              <Col lg={12}>
                <DetailRow childrenClasses="text-uppercase" title="Dirección">
                  {client.terceroUbicacion.direccionRes}
                  {client.terceroUbicacion.infoMunicipioRes ? " / " + client.terceroUbicacion.infoMunicipioRes : ""}
                  {client.terceroUbicacion.infoDepartamentoRes ? " / " + client.terceroUbicacion.infoDepartamentoRes : ""}
                  {client.terceroUbicacion.infoPaisRess ? " / " + client.terceroUbicacion.infoPaisRess : ""}
                </DetailRow>
              </Col>
            </Row>
          ) : <Label for="pagaduria" className="py-4">
            <RequiredMarked />
            Por favor <a className='fw-bold pointer' onClick={onOpenModal}>seleccione</a> un cliente.
          </Label>}
        </>
      </CardBody>
    </Card>
  );
};

export default GeneralDataClient;
